import React from 'react';
import './Footer.css'


const Footer = () => {
  
    return (
        <div className='footer'>
          
            <p style={{paddingTop:'100px'}}>copyright 2021 | Faraz Ahmed</p>
            <div className='mt-4'>
            <a
              href="https://www.facebook.com/profile.php?id=100029928137402"
              target="_blank"
              rel="noopener noreferrer"
              className="me-4 text-reset"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
           
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="me-4 text-reset"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/faraz-ahmed3/"
              target="_blank"
              rel="noopener noreferrer"
              className="me-4 text-reset"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/faraz12948"
              target="_blank"
              rel="noopener noreferrer"
              className="me-4 text-reset"
            >
              <i className="fab fa-github"></i>
            </a>
          </div>
            
        </div>
    );
};

export default Footer;